import { NavLink } from 'react-router-dom'
import { useCurrentUser } from '~/lib/auth/use-current-user'
import styles from './nav.module.scss'

type NavItem = {
  label: string
  to?: string
  soon?: boolean
  adminOnly?: boolean
}

const ITEMS: NavItem[] = [
  { label: 'today', to: '/' },
  { label: 'calendar', to: '/calendar' },
  { label: 'holidays', to: '/holidays' },
  { label: 'settings', to: '/settings', adminOnly: true },
  { label: 'admins', to: '/admins', adminOnly: true },
]

export function Nav() {
  const { data: me } = useCurrentUser()
  const isAdmin = me?.user.is_admin ?? false

  const visible = ITEMS.filter(item => !item.adminOnly || isAdmin)

  return (
    <nav className={styles.nav} aria-label="primary">
      {visible.map(item =>
        item.to ? (
          <NavLink
            key={item.label}
            to={item.to}
            end
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ''}`
            }
          >
            {item.label}
          </NavLink>
        ) : (
          <span
            key={item.label}
            className={`${styles.link} ${styles.disabled}`}
            aria-disabled="true"
            title="Available in a later release."
          >
            {item.label}
            <span className={styles.soon}>(soon)</span>
          </span>
        )
      )}
    </nav>
  )
}
